<template>
  <div v-click-outside="closeOptionsModal" class="campaign-options-modal">
    <h1 class="options-title">{{ $t("campaignManager.options") }}</h1>
    <div class="options">
      <button
        v-if="!currentFeed?.isGeneralFeed && productsCount === 0"
        class="option-button"
        @click="setAsGenericFeed"
      >
        <GeneralFeeds class="icon generic-icon" />
        {{ $t("create.bulk.genericFeed") }}
      </button>
      <button
        v-else-if="currentFeed?.isGeneralFeed && productsCount === 0"
        class="option-button"
        @click="unsetGenericFeed"
      >
        <GeneralFeeds class="icon generic-icon" />
        {{ $t("create.bulk.unsetGenericFeed") }}
      </button>
      <button v-if="!allowReorder" class="option-button" @click="$emit('enable-reorder')">
        <ReorderIcon class="icon reorder-icon" />
        {{ $t('create.bulk.reorderFeeds') }}
      </button>
      <button v-else class="option-button" @click="$emit('disable-reorder')">
        <ReorderIcon class="icon reorder-icon" />
        {{ $t('create.bulk.finishReorderFeeds') }}
      </button>
      <button class="option-button tag-button" @click="addTags">
        <AddTagIcon class="icon tag-icon" />
        {{ $t('create.bulk.addTags') }}
      </button>
      <button class="option-button" @click="cloneFeed">
        <CloneIcon class="icon" />
        {{ $t("create.bulk.cloneFeed") }}
      </button>
      <button class="option-button" @click="deleteFeed">
        <DeleteIcon class="icon" />
        {{ $t("create.bulk.deleteFeed") }}
      </button>
    </div>
  </div>
</template>

<script>
import DeleteIcon from "@/assets/svg/delete.svg?inline";
import CloneIcon from "@/assets/svg/clone-icon.svg?inline";
import GeneralFeeds from "@/assets/svg/generic-feed-icon-small.svg?inline";
import ReorderIcon from "@/assets/svg/small-reorder-icon.svg?inline"
import AddTagIcon from "@/assets/svg/add-tag-icon-outline.svg?inline";

export default {
  components: {
    DeleteIcon,
    CloneIcon,
    GeneralFeeds,
    ReorderIcon,
    AddTagIcon,
  },
  props: {
    currentFeedEditIndex: {
      type: Number,
      required: true,
    },
    currentFeed: {
      type: Object,
      required: true,
    },
    productsCount: {
      type: Number,
      required: true,
    },
    allowReorder: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    closeOptionsModal() {
      this.$emit("close-options-modal");
    },
    deleteFeed() {
      this.$emit("open-delete-feed-modal", this.currentFeedEditIndex);
    },
    cloneFeed() {
      this.$emit("clone-feed", this.currentFeedEditIndex);
    },
    setAsGenericFeed() {
      this.$emit("set-generic-feed", this.currentFeedEditIndex);
    },
    unsetGenericFeed() {
      this.$emit("unset-generic-feed", this.currentFeedEditIndex);
    },
    addTags() {
      this.$emit("add-tags-to-feed", this.currentFeedEditIndex);
    },
  },
};
</script>
<style lang="scss" scoped>
.campaign-options-modal {
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.25);
  padding: 16px;
  width: 200px;
  min-height: 100px;
  z-index: 99;
  background: white;
  position: absolute;
  top: 0px;
  right: 64px;
  border-radius: 4px;
}
.options-title {
  @include base-font;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  color: $light-grey;
  margin-bottom: 16px;
}
.options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}
.reorder-icon {
  circle {
    fill: $dark-grey;
  }
}
.tag-icon {
  margin-top: 2px;
  path {
    fill: $dark-grey;
    transform: scale(.8)
  }
}
.option-button {
  @include base-font;
  background: transparent;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: $dark-grey;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  position: relative;
  text-align: left;
  &:hover {
    width: 100%;
    background: $dark-purple;
    color: white;
    border-radius: 4px;
    text-align: left;
    .icon path {
      fill: white;
    }
    .reorder-icon circle {
      fill: white;
    }
    .edit-icon path {
      stroke: white;
    }
  }
}
.tag-button {
  gap: 4px;
}
</style>
